import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { DeleteOutlined, DownloadOutlined, VisibilityOutlined } from "@mui-symbols-material/w300"
import type { MouseEvent } from "react"
import React from "react"

import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface GoodsReceiptUploadsRowDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  onView: (e: MouseEvent<HTMLLIElement>) => void
  onDownload: (e: MouseEvent<HTMLLIElement>) => void
  onRemove: (e: MouseEvent<HTMLLIElement>) => void
}

export const GoodsReceiptUploadsRowDropdownMenu: React.FC<GoodsReceiptUploadsRowDropdownMenuProps> = ({
  anchorEl,
  onClose,
  onView,
  onDownload,
  onRemove,
}) => {
  const { hasPermissions } = usePermissionManager()
  const canMaintain = hasPermissions([PermissionActionType.WAREHOUSE_RECEIVING_MAINTENANCE])

  return (
    <Menu anchorEl={anchorEl} open onClose={onClose} data-test='goods-receipt-file-row-dropdown-menu'>
      <MenuItem onClick={onView} data-test='goods-receipt-file-view-menu-item'>
        <ListItemIcon>
          <VisibilityOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='View Document' />
      </MenuItem>
      <MenuItem onClick={onDownload} data-test='goods-receipt-file-download-menu-item'>
        <ListItemIcon>
          <DownloadOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Download' />
      </MenuItem>
      {canMaintain && (
        <MenuItem onClick={onRemove} data-test='goods-receipt-file-delete-menu-item'>
          <ListItemIcon>
            <DeleteOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
          </ListItemIcon>
          <ListItemText primary='Delete Document' />
        </MenuItem>
      )}
    </Menu>
  )
}
